import type { AddFieldPlacementTarget } from '@cli-types/core-engine/add-field.js'
import type { FormSchema } from '@cli-types/core-engine/schema.js'
import { collectFormNestedTargets } from './collect-form-nested-targets.js'
import { ensureFormFields } from './ensure-form-fields.js'

export function buildFormPlacementTargets(schema: FormSchema): AddFieldPlacementTarget[] {
  const targets: AddFieldPlacementTarget[] = []

  if (schema.steps) {
    for (const step of schema.steps) {
      targets.push({
        id: `step:${step.name}`,
        label: `step "${step.name}" fields`,
        scope: 'schema',
        getFields: () => step.fields
      })
      collectFormNestedTargets(step.fields, `step:${step.name}`, 'schema', targets)
    }
    return targets
  }

  targets.push({
    id: 'root:fields',
    label: 'top-level fields',
    scope: 'schema',
    getFields: () => ensureFormFields(schema)
  })
  collectFormNestedTargets(schema.fields ?? [], 'fields', 'schema', targets)
  return targets
}
